import { Card, CardContent } from '@src/design-system/card';
import { Text } from '@src/design-system/text';
import SkeletonLoader from '@src/shared/components/reusables/skeleton';

import type { ReactNode } from 'react';
import { cn } from '@src/design-system/helpers';

interface StatCardProps {
  title: string;
  value: string | number | ReactNode;
  icon?: ReactNode;
  change?: string;
  type?: 'success' | 'danger';
  subText?: string;
  isLoading: boolean;
  className?: string;
  titleClassName?: string;
  cardContentClassName?: string;
  valueClassName?: string;
}

export const StatCard = ({
  title,
  value,
  icon,
  change,
  type = 'success',
  subText,
  isLoading,
  className,
  cardContentClassName,
  titleClassName,
  valueClassName,
}: StatCardProps) =>
  isLoading ? (
    <div className='flex-1 rounded-2xl'>
      <SkeletonLoader height={200} />
    </div>
  ) : (
    <Card
      className={cn(
        'rounded-2xl border border-primary-100 bg-white shadow-sm py-4 pb-0 flex-1',
        className
      )}
    >
      <CardContent
        className={cn('flex flex-col gap-2 px-3 pb-4', cardContentClassName)}
      >
        <div className='flex justify-between items-start'>
          <Text
            variant='p'
            className={cn(
              'text-[#0F132499] font-medium xl:text-sm text-xs',
              titleClassName
            )}
          >
            {title}
          </Text>
          {icon && (
            <div className='bg-primary-50 w-[40px] h-[40px] flex items-center justify-center rounded-lg'>
              {icon}
            </div>
          )}
        </div>
        <p
          className={cn(
            'font-semibold text-[#14151A] text-[30px]',
            valueClassName
          )}
        >
          {value}
        </p>
        {change &&
          (type === 'success' ? (
            <span
              className={
                'text-sm text-green-500  w-[fit-content] bg-[#D1FAE4] px-2 py-1 rounded-lg'
              }
            >
              {change}
            </span>
          ) : (
            <span
              className={
                'text-sm text-red-500  w-[fit-content] bg-[#FCE5E4] px-2 py-1 rounded-lg'
              }
            >
              {change}
            </span>
          ))}
        {subText && <Text className='text-xs text-gray-400'>{subText}</Text>}
      </CardContent>
    </Card>
  );
